/**
 * Was das Anlegen auslöst, so wie der Server es tut (ManualBookingService): Sperre auf allen
 * Kanälen, Zahlungsaufforderung per Stripe, Gastzugang nach der Zahlung.
 */
const STEPS = [
  'Die Nächte werden für alle verbundenen Buchungsportale gesperrt; die Übertragung läuft im Hintergrund.',
  'Der Gast bekommt per E-Mail eine Zahlungsaufforderung über Stripe (Stripe muss verbunden sein). Bis zur Zahlung steht die Buchung auf „Zahlung offen“; unter dem Stripe-Mindestbetrag gilt sie gleich als bezahlt.',
  'Den Check-in-Zugang bekommt der Gast nach der Zahlung.',
  'Die Buchung steht sofort in der Liste und im Kalender.',
];

export function ManualBookingAfter() {
  return (
    <section
      aria-labelledby="manual-after"
      className="bg-paper rounded-tile flex flex-col gap-1.5 px-4 py-3.5"
    >
      <h3 id="manual-after" className="font-serif text-base font-bold">
        Was danach passiert
      </h3>
      <ul className="text-ink-soft flex flex-col gap-1 text-[13px]">
        {STEPS.map((step) => (
          <li key={step}>· {step}</li>
        ))}
      </ul>
    </section>
  );
}
